// Build-time configuration (Create React App inlines REACT_APP_* env vars at build time).
// REACT_APP_API_URL: base URL of the backend (e.g. https://api.example.com).
// When unset or empty the app runs in no-backend mode: login, register and
// multiplayer/matchmaking UI is hidden and no API or socket requests are made.
const rawApiUrl = (process.env.REACT_APP_API_URL || "").trim();

export const API_URL: string | null = rawApiUrl ? rawApiUrl.replace(/\/+$/, "") : null;
export const BACKEND_ENABLED = API_URL !== null;
